import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Core from "../Core";
import countriesList from "../Data/Countries.json";

import { Button, Form, FormGroup, ControlLabel } from "react-bootstrap";

class CustomerDetailPage extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };

    this.onError = this.onError.bind(this);
    this.Close = this.Close.bind(this);
  }

  currentCustomer() {
    const { stores, id } = this.props;
    const customer = stores.data.CustomersStore.findById(id);
    return customer;
  }

  onSaveClick() {
    const customer = this.currentCustomer();

    if (customer && customer.isValid()) {
      customer.store.storeModel(customer, this.Close, this.onError);
    }
  }

  onError(id, error) {
    if (error.response && error.response.headers && error.response.headers["x-error-message"]) {
      this.setState({ error: error.response.headers["x-error-message"] });
    }
  }

  onCancelClick() {
    this.Close();
  }

  Close() {
    const { stores } = this.props;
    if (stores.currentUser.user.isAdmin) {
      window.location.hash = `#customers-list`;
    } else {
      window.location.hash = ``; // home screen
    }
  }

  handleChange(key, e) {
    const customer = this.currentCustomer();
    if (customer && e.target) {
      let value = e.target.value;
      if (value === "") value = null;
      customer[key] = value;
    }
  }

  validateValue(value) {
    let validationState = null;

    if (value === null || value === undefined || value.length === 0 || value === "") {
      validationState = "error";
    }

    return validationState;
  }

  render() {
    const { stores } = this.props;

    const customer = this.currentCustomer();
    if (!customer) throw new Error("Customer cannot be null");

    const countryRows = countriesList.map((country) => {
      return (
        <option key={country.code} value={country.code}>
          {country.name}
        </option>
      );
    });

    let internalRemark = null;
    if (stores.currentUser.user.isAdmin) {
      internalRemark = (
        <div className="row">
          <div className="col-sm-6">
            <FormGroup>
              <ControlLabel>Internal remark</ControlLabel>
              <Core.Components.Inputs.Text rows="5" componentClass="textarea" model={customer} dataMember={"InternalRemark"} />
            </FormGroup>
          </div>
        </div>
      );
    }

    let options = [
      <option key={1} value={1}>
        Never
      </option>,
      <option key={2} value={2}>
        1 week
      </option>,
      <option key={3} value={3}>
        2 weeks
      </option>,
      <option key={4} value={4}>
        4 weeks
      </option>,
      <option key={5} value={5}>
        3 months
      </option>,
      <option key={6} value={6}>
        1 year
      </option>,
    ];

    let errorMessage = null;
    if (this.state.error) errorMessage = <div className="alert alert-danger">{this.state.error}</div>;

    return (
      <div>
        <div className="row">
          <h1>Customer details</h1>
        </div>

        <Form className="well">
          <div className="row">
            <FormGroup controlId="CustomerName" validationState={this.validateValue(customer.Name)} className="col-sm-4">
              <ControlLabel>Name</ControlLabel>
              <Core.Components.Inputs.Text type={"text"} model={customer} dataMember={"Name"} required={true} />
            </FormGroup>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <FormGroup controlId="CustomerTelephone">
                <ControlLabel>Telephone</ControlLabel>
                <Core.Components.Inputs.Text type={"tel"} model={customer} dataMember={"Telephone"} required={true} />
              </FormGroup>
            </div>
          </div>

          <div className="row">
            <FormGroup controlId="CustomerEmail" validationState={this.validateValue(customer.Email)} className="col-sm-4">
              <ControlLabel>Email</ControlLabel>
              <Core.Components.Inputs.Text type={"email"} model={customer} dataMember={"Email"} required={true} />
            </FormGroup>
          </div>

          <br />

          <div className="row">
            <div className="col-sm-6">
              <FormGroup controlId="CustomerAddress" validationState={this.validateValue(customer.AddressLine1)}>
                <ControlLabel>Address</ControlLabel>
                <Core.Components.Inputs.Text
                  type={"text"}
                  placeholder={"Street, number, ..."}
                  model={customer}
                  dataMember={"AddressLine1"}
                  required={true}
                />
              </FormGroup>
            </div>
            <div className="col-sm-6" />
          </div>

          <div className="row">
            <FormGroup controlId="CustomerPostalCode" className="col-sm-2">
              <ControlLabel>Postal code</ControlLabel>
              <Core.Components.Inputs.Text type={"text"} model={customer} dataMember={"PostalCode"} required={true} />
            </FormGroup>

            <FormGroup controlId="CustomerCity" validationState={this.validateValue(customer.City)} className="col-sm-4">
              <ControlLabel>City</ControlLabel>
              <Core.Components.Inputs.Text type={"text"} model={customer} dataMember={"City"} required={true} />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-sm-4" controlId="formControlsSelect">
              <ControlLabel>Country</ControlLabel>
              <Core.Components.Inputs.Select value={"BE"} model={customer} dataMember={"CountryId"} required={true} options={countryRows} />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-sm-4" controlId="formControlsSelect">
              <ControlLabel>Password expiration time</ControlLabel>
              <Core.Components.Inputs.Select value={1} model={customer} dataMember={"PasswordExpirationTime"} required={true} options={options} />
            </FormGroup>
          </div>

          {internalRemark}

          <br />

          <div className="row">
            <FormGroup className="col-sm-4">
              <ControlLabel>Last updated</ControlLabel>
              <Core.Components.Inputs.Date model={customer} dataMember={"LastUpdated"} timeFormat={true} readOnly={"readOnly"} />
            </FormGroup>
          </div>

          <div className="row">
            <div className="col-sm-4">{errorMessage}</div>
          </div>

          <div className="row">
            <div className="pull-right">
              <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}>
                Save
              </Button>
              <Button bsStyle="link" onClick={this.onCancelClick.bind(this)}>
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default inject("stores")(observer(CustomerDetailPage));



// WEBPACK FOOTER //
// ./src/Pages/CustomerDetailPage.js